import * as React from "react";
import { Textarea } from "@fluentui/react-components";
import { FluentField } from "./Fluent-Field";
import PropTypes from "prop-types";
import { FluentButton } from "./Fluent-Button";
import FluentUiIcon from "../../assets/fluent-ui-icon";
import "./fluent-overide.scss";

export const FluentInputAreaButtonComboBox = ({
  label,
  disabled,
  validationMessage,
  required,
  size,
  defaultValue,
  onChange,
  onBlur,
  placeholder,
  onClick,
  icon,
  buttonText,
  buttonDisabled,
  noKey = false
}) => {
  return (
    <>
        <div className="fluent-input-area-button-combo-box">
            <div className="input-field-wrapper">
                <FluentField
                    size={size}
                    label={label}
                    validationMessage={validationMessage}
                    required={required}
                    className="w-100"
                >
                </FluentField>
            </div>
            <FluentButton
                disabled={buttonDisabled}
                appearance = "outline"
                text={buttonText}
                onClick={onClick}
                icon={
                    <FluentUiIcon 
                        name={icon} 
                        color={buttonDisabled ? "#bdbdbd" : "#0F6CBD"} 
                        size={20} 
                    />}
            />
        </div>
        <Textarea
            placeholder={placeholder}
            defaultValue={defaultValue}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
            className="fluentInput w-100 mt-2"
            resize="vertical"
            key={noKey ? null : defaultValue}
        />
    </>
  );
};

FluentInputAreaButtonComboBox.propTypes = {
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    validationMessage: PropTypes.string,
    required: PropTypes.bool,
    size: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    buttonText: PropTypes.string,
    buttonDisabled: PropTypes.bool,
};
